import { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { getUserProfileWithRedirect, UserProfile } from './Services/graphService';

const AUTHORITY = 'https://login.microsoftonline.com/560ec2b0-df0c-4e8c-9848-a15718863bb6';

const useUserProfile = () => {
  const { instance } = useMsal();

  const requestProfileData = useCallback(async (): Promise<UserProfile | null> => {
    try {
      const profile = await getUserProfileWithRedirect(instance, AUTHORITY, true);
      return profile;
    } catch (error) {
      console.error("Failed to get user profile data:", error);
      return null;
    }
  }, [instance]);

  return { requestProfileData };
};

export default useUserProfile;